import React, { useEffect, useState } from 'react';
import { 
FormControl
, FormControlLabel
, Grid
, Switch
, TextField
, Typography
, FormHelperText
, Tooltip
, Zoom
, Select, 
List,
ListItem,
ListItemText} from '@material-ui/core';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';

import ErrorIcon from '@material-ui/icons/Error';
import helpSvg from '../assets/img/help.svg';

import { connect, useDispatch, useSelector } from 'react-redux';
import { Field, change, getFormValues } from 'redux-form';

import slice from '../states/shell/slice';

import PeInput from './PeInput';
import useStyles from '../styles/styles';
import { makeStyles } from '@material-ui/core/styles';
import { handleFieldChange } from '../helpers/renderHelper';

const useCustomStyles = makeStyles(theme => ({
    PeAddressFields_control: {
        // margin: '40px 0 30px 0',
        padding: theme.spacing(2),
    },
    PeAddressFields_icon: {
        color: theme.palette.text.secondary,
        paddingRight: '5px',
    },
}));

const formName = 'battery-form';

const ManualAddressField = ({formValues}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const state = useSelector((state) => ({
    lastPostCode: state.shell.productData.lastPostCode,
  }));

  const [address, setAddress] = useState(formValues?.address ? formValues?.address : '');
  const [postal_code, setPostal_code] = useState(formValues?.zip ? formValues?.zip : '');
  const [locality, setLocality] = useState(formValues?.locality ? formValues?.locality.toUpperCase() : '');
  const austrialianStates = [
    { label: "Select State", value: "" },
    { label: "NSW", value: "NSW" },
    { label: "QLD", value: "QLD" },
    { label: "SA", value: "SA" },
    { label: "TAS", value: "TAS" },
    { label: "VIC", value: "VIC" },
    { label: "WA", value: "WA" },
    { label: "ACT", value: "ACT" }
  ]; 
  const [addressState, setAddressState] = useState(formValues?.state ? formValues?.state : '');
  const [country, setCountry] = useState('Australia');
  const [full_address, setFull_address] = useState(formValues?.full_address ? formValues?.full_address : '');
 
  useEffect(() => {
    if(address && locality && addressState && country && postal_code) {
      setFull_address(`${address}, ${locality.toUpperCase()} ${addressState} ${postal_code}, ${country}`);
      dispatch(change(formName, 'full_address', full_address));
      dispatch(change(formName, 'state', addressState))
      // handle change state
      handleFieldChange('state', dispatch, formName, addressState);
    }

  }, [dispatch, address, locality, addressState, country, postal_code, full_address]);
  
  useEffect(() => {
    // console.log(state.lastPostCode, postal_code);
    if (postal_code && postal_code.length === 4 && postal_code !== state.lastPostCode) {
      // update last post code for the first time and in case difference
      dispatch(slice.actions.updateLastPostCode(postal_code));
    } // eslint-disable-next-line
  }, [postal_code, dispatch]);

  const SelectState = () => {
    return (
      <div className={classes.padding} >
          <FormControl variant="outlined" fullWidth>
              <h3 className={classes.label}>{<span className={classes.required}>*</span>}&nbsp;State</h3>
              <Select className={classes.input} value={addressState} onChange={event => { setAddressState(event.target.value) }} native>
                  {austrialianStates.map((state, index) => {
                      return (
                        <option key={index} value={state.value}>{state.label}</option>
                      );
                  })}
              </Select>
          </FormControl>
      </div>
    );
  };

  return (<div>
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <Field required 
          name="address" 
          label="Address" 
          isShowLabel={false}
          onChange={(event) => {setAddress(event.target.value)}} 
          onBlur={() => dispatch(change(formName, 'address', address))} 
          component={PeInput} 
          placeholder="Enter your address"
        />
      </Grid>         
    </Grid>
    <Grid container spacing={3} style={{paddingTop: '20px'}}>
      <Grid item xs={6} sm={12} md={3}>
        <Field required name="locality" label="Suburb" onChange={(event) => {setLocality(event.target.value)}} onBlur={() => dispatch(change(formName, 'locality', locality))} component={PeInput} />
      </Grid>
      <Grid item xs={6} sm={12} md={3}>
        <Field required name="state" label="State" value={addressState} component={SelectState} />                                 
      </Grid>
      <Grid item xs={6} sm={12} md={3}>
        <Field required name="zip" label="Postcode" onChange={(event) => {setPostal_code(event.target.value)}} onBlur={() => dispatch(change(formName, 'zip', postal_code))} component={PeInput} />
      </Grid>
      <Grid item xs={6} sm={12} md={3}>
        <Field required name="country_iso2" label="Country" onChange={(event) => {setCountry(event.target.value)}} onBlur={() => dispatch(change(formName, 'country_iso2', country))} component={PeInput} />
      </Grid>
    </Grid>
  </div>);
};

const AddressAutoComplete = ({input, id, label, value, required, toolTip, meta: { touched, error }, formValues}) => {
 const classes = useStyles();
 const [address, setAddress] = useState(formValues?.full_address ? formValues?.full_address : '');
 const [subpremise, setSubpremise] = useState('');
 const [street_number, setStreet_number] = useState('');
 const [route, setRoute] = useState('');
 const [postal_code, setPostal_code] = useState(formValues?.zip ? formValues?.zip : '');
 const [locality, setLocality] = useState(formValues?.locality ? formValues?.locality : '');
 const [addressState, setAddressState] = useState(formValues?.state ? formValues?.state : '');
 const [country, setCountry] = useState(formValues?.country_iso2 ? formValues?.country_iso2 : '');
 const [addressDetailField, setAddressDetailField] = useState(formValues?.address ? formValues?.address : '');
 const [coordinates, setCoordinates] = useState({ lat: formValues?.lat ? formValues?.lat : '', lng: formValues?.lon ? formValues?.lon : '' });
 const [toggleAddressField, setToggleAddressField] = useState(false);
//  const [business_name, setBusiness_name] = useState('Residential');
 const [addressResults, getAddressResults] = useState([]);
 const [useAutoComplete, setUseAutocomplete] = useState(true);

 const classesCustom = useCustomStyles();
 const dispatch = useDispatch();
 const state = useSelector((state) => ({
  lastPostCode: state.shell.productData.lastPostCode,
  layout: state.shell.layout,
 }));

 const handleSelect = async value => {
  const results = await geocodeByAddress(value);
  const latlng = await getLatLng(results[0]);
  const { address_components } = results[0];

  getAddressResults(address_components);
  setAddress(value);
  setCoordinates(latlng);
 };
  //Restrictions Search
 const searchOptions = {
    componentRestrictions: {country: 'AU'},
    types: ['address']
  }

 //Field will unmounth and update if address change.
 useEffect(() => {
  addressResults.forEach(e =>
      e.types.indexOf('subpremise') !== -1 ? setSubpremise(e.short_name.replace(/[^0-9]/g, ''))
    : e.types.indexOf('street_number') !== -1 ? setStreet_number(e.short_name)
    : e.types.indexOf('route') !== -1 ? setRoute(e.short_name)
    : e.types.indexOf('postal_code') !== -1 ? setPostal_code(e.short_name)
    : e.types.indexOf('locality') !== -1 ? setLocality(e.long_name.toUpperCase())
    : e.types.indexOf('administrative_area_level_1') !== -1 ? setAddressState(e.short_name)
    : e.types.indexOf('country') !== -1 ? setCountry(e.long_name)
    : '');
  setCoordinates(coordinates); //Set new coordinates
  return () => {
    setSubpremise("");
    setStreet_number("");
    setRoute("");
    setPostal_code("");
    setLocality("");
    setAddressState("");
    setCountry("");
    setCoordinates({ lat: '', lng: '' });
  }
 }, [coordinates, addressResults]);

 // Set Address in field and Update form values
 useEffect(() => {
  let addressTmp =  `${subpremise ? subpremise.concat('/') : ''}${street_number} ${route}`;
  setAddressDetailField(addressTmp);
  // setAddressDetailField(subpremise && street_number && route ? [[subpremise, street_number].join("/"), route].join(" ") : route ? route : "");
  // update form values
  dispatch(change(formName, 'address', Boolean(addressDetailField) && addressDetailField === " " ? addressTmp : addressDetailField));
  dispatch(change(formName, 'zip', postal_code));
  dispatch(change(formName, 'locality', locality ? locality.toUpperCase() : ''));
  dispatch(change(formName, 'state', addressState));
  dispatch(change(formName, 'country_iso2', country));
  dispatch(change(formName, 'lat', coordinates.lat));
  dispatch(change(formName, 'lon', coordinates.lng));
  dispatch(change(formName, 'full_address', convertToFullAddress()));
  // handle change state
  handleFieldChange('state', dispatch, formName, addressState);
 }, [subpremise, street_number, route, postal_code, locality, addressState, country, coordinates]); // eslint-disable-line

 // Convert to to full address
 const convertToFullAddress = () => {
  if (addressDetailField && locality && addressState && country) {
    return addressDetailField.concat(', ').concat(locality ? locality.toUpperCase() : '')
    .concat(' ').concat(addressState)
    .concat(' ').concat(postal_code)
    .concat(', ').concat(country);
  }
  return '';
 }

 useEffect(() => {
  // console.log(state.lastPostCode, postal_code);
  if (postal_code && postal_code !== state.lastPostCode) {
    // update last post code for the first time and in case difference
    dispatch(slice.actions.updateLastPostCode(postal_code));
  } // eslint-disable-next-line
 }, [postal_code, dispatch]);
 
 const onError = (status, clearSuggestions) => {
  console.log('Google Maps API returned error with status: ', status);
  clearSuggestions();
 };

 const handleToggle = () => {
  setUseAutocomplete(!useAutoComplete); 
  setToggleAddressField(false);
 }
//  const handleBussinessSelect = event => {
//   setBusiness_name(event.target.value);
//  };

// handle Form value change
 useEffect(()=>{
  formValues.full_address && setAddress(formValues.full_address);
  formValues.zip && setPostal_code(formValues.zip);
  formValues.locality && setLocality(formValues.locality);
  formValues.state && setAddressState(formValues.state);
  formValues.country_iso2 && setCountry(formValues.country_iso2);
  formValues.address && setAddressDetailField(formValues.address);
 }, [formValues.full_address, formValues.zip, formValues.locality, formValues.state, formValues.country_iso2, formValues.address]);

 return (
  <div id={id} className={classesCustom.PeAddressFields_control}>
    <FormControl error={Boolean(error)}  variant="outlined" fullWidth>
      <input type="hidden" id={id} name={id} value={value} required={required} {...input}></input>
      <div className={classes.labelArea}>
        <h3 className={classes.label}>
          {required && <span className={classes.required}>*</span>}&nbsp;{label}
        </h3>
        {state.layout !== 2 && toolTip && <Tooltip title={toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
          <img src={helpSvg} alt="help" className={classes.iconHelp}/>
        </Tooltip>}
      </div>

      <div className={classes.extraControl}>
        {useAutoComplete && <FormControlLabel style={{color: '#9F9F9F', paddingRight: '10px'}} 
          control={<Switch size="small" color="primary" checked={toggleAddressField} />} 
          label="Address Detail" 
          onClick={() => setToggleAddressField(!toggleAddressField)} 
        />}
        <FormControlLabel style={{color: '#9F9F9F'}} 
          control={<Switch size="small" color="primary" checked={useAutoComplete} />} 
          label="Auto-complete" 
          onClick={handleToggle} 
        />
      </div>

      {useAutoComplete ? <PlacesAutocomplete value={address} searchOptions={searchOptions} 
        onChange={setAddress} 
        onSelect={handleSelect} 
        onError={onError}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
      <div>
        <TextField className={classes.autocomplete} fullWidth margin="normal" type="search" variant="outlined" required={required}
        {...getInputProps({
          placeholder: 'Enter your address',
        })}
        />
        <List component="nav">
          {loading ? <Typography>Loading...</Typography> : null}
          {suggestions.map((suggestion, index) => {
            return (
              <ListItem key={index}           
                style={{ backgroundColor: suggestion.active ? '#b5dbb8' : '#ebf7ec' }}
                onClick={handleSelect}
                {...getSuggestionItemProps(suggestion)}
                className={classes.suggestion}
                button
              >
                <LocationOnIcon className={classesCustom.PeAddressFields_icon} />
                <ListItemText 
                primaryTypographyProps={{ color: "textSecondary", variant: 'inherit' }}
                color="textSecondary" 
                primary={suggestion.description} />
              </ListItem>
            );
          })}
        </List>
        {useAutoComplete ? error && <FormHelperText className={classes.helpText} component="div">
        <ErrorIcon fontSize="small"/>
        <p style={{margin: 0, padding: 0}}>&nbsp;{error}</p>
        </FormHelperText> : null}
      </div>
      )}
      </PlacesAutocomplete> : <ManualAddressField formValues={formValues}/>}
    </FormControl>

     {/* <RadioGroup value={business_name} onChange={handleBussinessSelect}>
      <FormControlLabel value={'Residential'} label={'Residential'} control={<Radio color="primary" />} />
      <FormControlLabel value={'Commercial'} label={'Commercial'} control={<Radio color="primary" />} />
     </RadioGroup> */}
     <Grid container spacing={4} style={{ display: toggleAddressField ? 'flex' : 'none' }} className={classes.addressDetail}>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="address" className={classes.input} label="Address" size="small" value={addressDetailField ? addressDetailField : formValues?.address ? formValues?.address : ''} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="zip" label="Postcode" size="small" value={postal_code} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="locality" label="Locality" size="small" value={locality} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="state" label="State" size="small" value={addressState} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="country_iso2" label="Country" size="small" value={country} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="lat" label="Latitude" size="small" value={coordinates.lat} fullWidth/>
      </Grid>
      <Grid item xs={6} sm={3}>
       <TextField disabled name="lon" label="Longitude" size="small" value={coordinates.lng} fullWidth/>
      </Grid>
     </Grid>
  </div>
  );
};

export default connect(state => ({
  formValues: getFormValues(formName)(state)})
)(AddressAutoComplete);